import React, { ReactElement } from 'react';
import PatientsOverview from '../../../components/patient/PatientsOverview';

const PatientsPage = (): ReactElement => {
  return <PatientsOverview variant="therapist" />;
};

export default PatientsPage;
